import { render } from "./ExperienceInRestaurantServices.vue?vue&type=template&id=549cebe7&scoped=true"
import script from "./ExperienceInRestaurantServices.vue?vue&type=script&lang=js"
export * from "./ExperienceInRestaurantServices.vue?vue&type=script&lang=js"

import "./ExperienceInRestaurantServices.vue?vue&type=style&index=0&id=549cebe7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-549cebe7"]])

export default __exports__